import { Component, Input, HostBinding } from "@angular/core";
import { Cell, Page } from "@app/data/catalog";
import { ThemeCreatorService } from "./theme-creator.service";

@Component({
  selector: "app-catalog-cell",
  templateUrl: "./catalog-cell.component.html",
  styleUrls: ["./catalog-cell.component.css"],
})
export class CatalogCellComponent {
  @Input() page: Page;
  @Input() cell: Cell;
  @Input() isPreview: boolean = false;

  // Property for sidebar visibility
  isSidebarVisible: boolean = false;

  constructor(private themeCreatorService: ThemeCreatorService) {}

  @HostBinding("style.left.%")
  get left() {
    return this.cell.x * 100;
  }

  @HostBinding("style.top.%")
  get top() {
    return this.cell.y * 100;
  }

  @HostBinding("style.width.%")
  get width() {
    return this.cell.width * 100;
  }

  @HostBinding("style.height.%")
  get height() {
    return this.cell.height * 100;
  }

  // Method to open sidebar
  onCellClick() {
    if (this.isPreview) {
      return;
    }
    this.themeCreatorService.notifyCellSelected(this.cell);
  }

  // Method to close sidebar
  closeSidebar() {
    this.isSidebarVisible = false;
  }
}
